const raw = process.env.REACT_APP_API_BASE || "https://www.ritasproperties.com";
const API_BASE = raw.trim().replace(/\/+$/, "");

if (raw.includes(",")) {
  throw new Error(`REACT_APP_API_BASE is invalid (contains comma): "${raw}"`);
}

export async function adminFetch(path: string, init: RequestInit = {}) {
  const headers = new Headers(init.headers || {});
  headers.set("Accept", "application/json");
  if (!headers.has("X-Locale") && typeof window !== "undefined") {
    const first = window.location.pathname.split("/").filter(Boolean)[0] || "";
    headers.set("X-Locale", first || "el");
  }

  const url = `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;

  // ✅ DEBUG LOGS
  console.log("[adminFetch] ->", (init.method || "GET"), url, {
    credentials: "include",
    headers: Object.fromEntries(headers.entries()),
  });

  const res = await fetch(url, { ...init, headers, credentials: "include" });

  // ✅ DEBUG LOGS
  console.log("[adminFetch] <-", res.status, res.url);

  return res;
}
